export const COLUMNSHITOS = [
    {
        header: 'Nombre',
        accessorKey: 'new_nombre',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha de vencimiento',
        accessorKey: 'new_fechavencimiento',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Estado',
        accessorKey: 'statuscode',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },

]

export const COLUMNSFORMACION = [
    {
        header: 'Nombre',
        accessorKey: 'new_name',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Tipo de formación',
        accessorKey: 'new_tipodeformacion',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Tipo de experiencia',
        accessorKey: 'cr879_tipodeexperienciadeaprendizaje',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Subdiciplina',
        accessorKey: 'new_subdisciplina',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },

]

export const COLUMNSTAREAS = [
    {
        header: 'Materia',
        accessorKey: 'new_materia',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Asunto',
        accessorKey: 'subject',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha de inicio',
        accessorKey: 'scheduledstart',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha de finalización',
        accessorKey: 'scheduledend',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },

]

export const COLUMNSHITOSACTIVIDADES = [
    {
        header: 'Orden dentro del hito',
        accessorKey: 'new_ordendentrodelhito',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Nombre de la actividad',
        accessorKey: 'subject',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Cantidad de días',
        accessorKey: 'new_cantidaddedias',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha de inicio',
        accessorKey: 'scheduledstart',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Comienzo real',
        accessorKey: 'actualstart',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fecha de vencimiento',
        accessorKey: 'scheduledend',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },
    {
        header: 'Fin real',
        accessorKey: 'actualend',
        Cell: ({ cell }) => <strong>{cell.getValue()}</strong>
    },

]